export default __webpack_public_path__ + "static/media/GELBE_SEITEN.b47171bd.png";